<div class="ada-container ada-col-1 ada-colspan-1 ada-flex-column ada-full-height">
	@if (aida.isSearchOpen()) {
		<ada-search-navigation
			[numberOfMatches]="searchResults().length"
			[(index)]="searchIndex"
			(close)="toggleSearch()"
			(indexChange)="indexChange($event)"
			(valueChange)="search($event)"
		/>
	}
	<div class="ada-container ada-col-1 ada-colspan-1 ada-flex-column ada-overflowY-auto ada-full-height">
		@let _nodes = service.displayNodes();
		@if (_nodes) {
			<div
				#Viewbox
				ada-viewbox
				[backgroundGridStyles]="backgroundGridStyles()"
				[hasBackgroundGrid]="true"
			>
				<div class="ada-llm-history-grid">
					@let _camera = Viewbox.camera();

					@for (_node of _nodes | keyvalue; track _node.key) {
						@if (_node.value.isVisible) {
							@let _isInFork = _node.value | adaIsInLlmFork: service.forks.activeForkId() : service.history.nodes();
							<div
								ada-background-color="background"
								ada-llm-history-node
								animate.enter="animated-pop-in"
								class="ada-border ada-border-2px ada-cursor-pointer"
								[attr.data-testid]="`ada-llm-node-${_node.key}`"
								[class.ada-border-primary]="_isInFork"
								[isExpanded]="_node.value | adaIsLlmNodeExpanded: service.collapsedNodeIds()"
								[ngStyle]="{
									'--column': _node.value.column + 1,
									'--row': _node.value.row + 1,
								}"
								[node]="_node.value"
								(click)="service.openDetails(_node.value, nodeComponentMap())"
								(isExpandedChange)="onNodeToggled(_node.value, $event)"
							></div>

							@let _from = _node.value.parent | adaLlmHistoryNodeBox: nodeComponentMap();
							@let _to = _node.value | adaLlmHistoryNodeBox: nodeComponentMap();
							@let _lineColor = _isInFork | adaLlmHistoryNodeColor: themes.theme();

							@if (_node.value.parent) {
								<svg
									ada-llm-history-node-connector
									[cameraZoom]="_camera.z"
									[from]="_from"
									[lineColor]="_lineColor"
									[to]="_to"
								></svg>
							}
						}
					}
				</div>
				<div
					ada-viewbox-control
					class="ada-display-flex ada-container ada-flex-column ada-flex-direction-column"
				></div>
			</div>
		} @else {
			<div class="ada-llm-history-empty">
				<ada-alert
					data-testid="ada-llm-conversation-history-empty-alert"
					[isClosable]="false"
					[title]="'No active conversation'"
				/>
			</div>
		}
	</div>
</div>
